import { useCallback } from "react";

export const useScrollToSection = () => {
  const scrollToSection = useCallback((id, offset = 0) => {
    const el = document.getElementById(id);
    if (!el) return;

    // Force a tiny scroll to allow repeated clicks to trigger smooth scroll
    window.scrollBy({ top: -1, behavior: "instant" });

    // Compute exact scroll position (for sticky headers)
    const y = el.getBoundingClientRect().top + window.pageYOffset + offset;

    // Scroll smoothly
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  return scrollToSection;
};